import { useLayoutEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import useActiveSbSubscription from '@/hooks/queries/useSbSubscription';
import { ProxyCard } from '@/components/PurchasePage/ProxyCard';
import { proxies } from '@/model/proxyTypes';
import Flex from '@/components/ui/Flex';
import { Clock } from 'lucide-react';
import Page from '@/components/ui/Page';
import { DesktopView, MobileView } from '@/components/responsive';
import ProxiesBuyFooter from '@/components/PurchasePage/ProxiesBuyFooter';
import OrderSummary from '@/components/PurchasePage/OrderSummary/OrderSummary';

export function ProxiesBuyPage() {
  const { data: activeSubscription } = useActiveSbSubscription();
  const navigate = useNavigate();
  const searchParams = useSearchParams()[0];
  const proxyType = searchParams.get('type');

  const [expandedBlocks, setExpandedBlocks] = useState({
    residential: !proxyType || proxyType === 'residential', // default to residential
    mobile: proxyType === 'mobile',
    datacenter: proxyType === 'datacenter',
    isp: proxyType === 'isp',
  });

  useLayoutEffect(() => {
    if (activeSubscription) {
      navigate('/settings', { replace: true });
    }
  }, [navigate, activeSubscription]);

  return (
    <>
      <Page.Container>
        <Page.Body>
          <div className="lg:flex lg:items-start gap-y-6 gap-x-7">
            <Flex.Col className="gap-4">
              <Page.Heading className="mb-1">
                <Page.Title>Choose your proxy plan</Page.Title>
              </Page.Heading>
              <div className="flex flex-col gap-y-3">
                {proxies.map((proxy) => (
                  <ProxyCard
                    key={proxy.type}
                    proxyInfo={proxy}
                    isExpanded={expandedBlocks[proxy.type]}
                    onToggle={() =>
                      setExpandedBlocks({
                        ...expandedBlocks,
                        [proxy.type]: !expandedBlocks[proxy.type],
                      })
                    }
                  />
                ))}
                <ISPComingSoon />
              </div>
            </Flex.Col>
            <DesktopView>
              <Flex.Col className="gap-4 w-full">
                <Page.Heading className="mb-1">
                  <Page.Title>Order summary</Page.Title>
                </Page.Heading>
                <OrderSummary />
              </Flex.Col>
            </DesktopView>
          </div>
        </Page.Body>
      </Page.Container>
      <MobileView>
        <ProxiesBuyFooter />
      </MobileView>
    </>
  );
}

function ISPComingSoon() {
  return (
    <div className="overflow-hidden rounded-lg border border-[#e9e9e9] bg-white shadow-xs hover:border-primary-purple transition-all hidden sm:block w-full">
      <div className="flex items-start gap-4 px-5 py-8 max-w-[778px]">
        <div className="bg-proxy-icon-bg h-11 aspect-square rounded-lg flex items-center justify-center text-white text-center text- font-medium">
          ISP
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-medium text-[#101828]">ISP proxy</h3>
          </div>
          <div className="flex items-center text-sm">
            <p className="text-sm">
              IP addresses provided by internet service providers (ISPs),
              blending the speed of datacenter proxies with the legitimacy of
              residential IPs.
            </p>
            <div className="flex flex-col items-center text-sm text-[#667085 text-center gap-2 hover:text-primary-purple transition-all">
              <Clock className="h-4 w-4" />
              <span className="text-nowrap">Coming soon</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
